import { type Context, createContext } from 'react';

/**
 * The context that holds the document outline. The level for the headline is increased per component that uses section
 * @public
 */
export const OverlayStackingContext: Context<number> = createContext<number>(0);
OverlayStackingContext.displayName = 'OverlayStackingContext';
